export default "__VITE_ASSET__SDBth6BE__"